import React from "react";
import {useMutation} from "react-query";
import Alert from "react-s-alert";
import {Button} from "@reside/ui";
import {Tooltip} from "../../../../atoms/tooltip";
import {buildResponseErrorMessage} from "../../../../services/api/errorHelpers";
import {QuicksightService} from "../../../../services/QuicksightService";

type Props = Readonly<{
  onSuccess: () => void;
}>;

export const SyncQuicksightDashboardsButton = ({onSuccess}: Props) => {
  const {mutate, isLoading} = useMutation(QuicksightService.syncDashboards, {
    onSuccess: () => {
      onSuccess();
      Alert.success("Sent request to discover dashboards");
    },
    onError: async resp => {
      Alert.error(await buildResponseErrorMessage(resp));
    },
  });

  return (
    <Tooltip content="Discovers dashboards from QuickSight. Use sparingly.">
      <Button
        color="primary"
        disabled={isLoading}
        outline
        size="small"
        onClick={() => mutate()}
        testId="discover-quicksight-dashboards-button"
      >
        {isLoading ? "Discovering Dashboards..." : "Discover Dashboards"}
      </Button>
    </Tooltip>
  );
};
